import View from '@shared/components/layout-default/layout-default-router-view';

export const notify = [
  {
    path: 'notifications',
    component: View,
    children: [
      {
        path: '',
        name: 'notify.notification.index',
        meta: {
          title: { code: 'notify.breadcrumb.notification.title' }
        },
        component: () =>
          import(/* webpackChunkName: "notify" */ '@notify/pages/notifications-list-page.vue')
      }
    ]
  }
];
